import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

@model.cacheDuration()
@model.urnResource('subscription_period')
@doc.path('/subscription_periods/{?id}')
export default class SubscriptionPeriodModel extends AccountServiceModel {
	private declare _tsFilters: {
		'id': id;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare name: Account_SubscriptionPeriodName;
	@doc.number declare value: number;
}
